import React from 'react'
import { Card, CardContent } from './ui/card'
import { Button } from './ui/button'
import { Link } from 'react-router-dom'

export function DevBoardsPage() {
  const boards = [
    {
      slug: 'ardugsm',
      name: 'ArduGSM',
      image: 'arduGSM-1.png',
      description: 'ArduGSM, Arduino UNO (Atmega328P), SIM800C GSM modülü, 2 adet röle ve buzzer barındıran tümleşik bir kontrol kartıdır. Dahili 3A regülatör sayesinde güvenilir güç bağlantısı sağlar. Type-C USB konnektörü ile Arduino kolayca programlanabilir.',
      features: [
        { label: 'Arduino UNO', value: 'ATmega328P' },
        { label: 'GSM Modül', value: 'SIM800C' },
        { label: 'Röle', value: '2 Adet' },
        { label: 'Buzzer', value: '1 Adet' },
        { label: 'SIM Kart', value: 'Mikro SIM (TVS korumalı)' },
        { label: 'Ses', value: 'Dahili mikrofon & hoparlör konnektörü' },
        { label: 'Anten', value: '3 dBi 90° SMA' },
        { label: 'Regülatör', value: 'Dahili LM2596S 3A voltaj regülatörü' },
        { label: 'Koruma', value: 'Ters polarite & TVS koruma' },
        { label: 'Bağlantı Türü', value: 'USB Type C' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A' },
      ],
    },
    {
      slug: 'esp32-ethernet-devboard',
      name: 'ESP32 Ethernet Devboard',
      image: 'esp32-eth_devboard.png',
      description: 'ESP32 Ethernet Geliştirme Modülü, Wi-Fi, Ethernet ve Bluetooth bağlantısını destekleyen, endüstriyel IoT projeleri için tasarlanmış bir geliştirme kartıdır. Dahili LAN8720 tabanlı Ethernet PHY arayüzü sayesinde doğrudan RJ45 portu üzerinden kablolu ağ bağlantısı sağlar. USB Type-C üzerinden programlanabilir ve Arduino IDE veya PlatformIO ortamında kolayca kullanılabilir.',
      features: [
        { label: 'Mikrodenetleyici', value: 'ESP32-WROOM-32D' },
        { label: 'Çekirdek', value: 'Dual-core (240 MHz’e kadar)' },
        { label: 'RAM', value: '520 KB' },
        { label: 'Flash', value: '4 MB (SPI Flash)' },
        { label: 'Bağlantı', value: 'Wi‑Fi / Ethernet (LAN8720) / Bluetooth v4.2' },
        { label: 'Programlama Arayüzü', value: 'USB Type‑C' },
        { label: 'Besleme', value: '5V (USB Type‑C veya 5V pin)' },
      ],
    },
    {
      slug: 'lorawan-devboard',
      name: 'LoRaWan DevBoard',
      image: 'gsm_role.png',
      description: 'LoRaWan DevBoard açıklama',
      features: [
        { label: 'Bağlantı Türü', value: 'LoRaWan' },
        { label: 'Modül', value: 'SX1276' },
        { label: 'Anten', value: '3 dBi 90° SMA' },
        { label: 'Çalışma Gerilimi', value: '3.3V' },
        { label: 'Bağlantı Türü', value: 'USB Type C' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A' },
      ],
    },
    {
      slug: 'ilimflight-pro',
      name: 'ilimFlight Pro Drone Kontrol Kartı',
      image: 'ilimFlight-Pro-gribg.png',
      description: 'ilimFlight Pro, ArduPilot destekleyen tüm araç tiplerinde (multikopter, sabit kanat, helikopter, rover, bot vb.) profesyonel seviyede yüksek doğruluk ve güvenilirlikle çalışmak üzere tasarlanmış, son nesil bir uçuş kontrol bilgisayarıdır.',
      features: [
        { label: 'Mimari', value: 'ARM Cortex-M7 | STM32 MCU' },
        { label: 'İşlem Hızı', value: '480 MHz' },
        { label: 'Yazılım Desteği', value: 'ArduPilot uyumlu' },
        { label: 'Çoklu Araç Desteği', value: 'Multikopter, Sabit Kanat, Helikopter, Rover, Bot vb.' },
        { label: 'IMU 1', value: '3 eksen jiroskop + 3 eksen ivmeölçer' },
        { label: 'IMU 2', value: 'Sensör Füzyonu için 6 eksen IMU' },
      ],
    },
    {
      slug: 'esp32-devboard',
      name: 'ESP32 DevBoard',
      image: 'gsm_role.png',
      description: 'ESP32 DevBoard açıklama',
      features: [
        { label: 'Bağlantı Türü', value: 'M2M SIM Kart / Hücresel Veri 10MB/Ay' },
        { label: 'Mobil Uygulama', value: '“Akıllı Cihaz Yönetimi” (Android/iOS)' },
        { label: 'Bağlanabilir Cihaz', value: '6 Adet – COM/NO/NC' },
        { label: 'Kontrol Kapasitesi', value: '10A @ 250VAC, 10A @ 30VDC' },
        { label: 'Okuma Girişi', value: '4 adet (Enerji vermeyin!)' },
        { label: 'Buzzer', value: '1 Adet' },
        { label: 'Anten', value: '3M' },
        { label: 'Çalışma Gerilimi', value: '12V DC 1A Adaptör' },
        { label: 'Cihaz Boyutları', value: 'RT 207 Ray Tipi Kutu (Panoya geçmeli / Duvara vida ile montaj)' },
      ],
    },
  ]

  return (
    <div className="py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-4xl font-bold text-foreground mb-8">Geliştirme Kartları</h1>
        <div className="grid grid-cols-1 gap-6">
          {boards.filter(board => board.slug !== 'lorawan-devboard' && board.slug !== 'esp32-devboard').map((board) => (
            <Card key={board.name} className="overflow-hidden w-full max-w-4xl mx-auto">
               <div className="flex items-center p-6 gap-6">
                 <div className="w-48 h-32 flex-shrink-0">
                   <Link to={`/urunler/gelistirme-kartlari/${board.slug}`}>
                   <img src={`/${board.image}`} alt={board.name} className="w-full h-full object-cover rounded-md" />
                   </Link>
                 </div>
                 <div className="flex-1">
                   <Link to={`/urunler/gelistirme-kartlari/${board.slug}`} className="hover:text-primary transition-colors">
                     <h3 className="text-xl font-semibold text-foreground mb-1">{board.name}</h3>
                   </Link>
                   <p className="text-sm text-muted-foreground">{board.description}</p>
                 </div>
                 <div className="flex-shrink-0">
                   <Link to={`/urunler/gelistirme-kartlari/${board.slug}`}>
                     <Button
                       variant="outline"
                       size="sm"
                     >
                       Detayları Görüntüle
                     </Button>
                   </Link>
                 </div>
               </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  )
}


